import type { ModelEffortRule } from "../effort";
import { defineAIProviderManifest } from "../manifest";

// Reasoning effort is model-specific, not provider-wide: `xhigh` (our `max`) is
// Codex-Max only, the lower levels apply to gpt-5/codex/o-series reasoning
// models, and non-reasoning models (gpt-4o, …) match no rule and get no knob.
// Order matters — the Codex-Max rule must precede the generic one. Shared with
// the Azure manifest, which exposes the same OpenAI models.
export const OPENAI_MODEL_EFFORTS: readonly ModelEffortRule[] = [
  { pattern: /codex-max/i, levels: ["low", "medium", "high", "max"] },
  { pattern: /gpt-5|codex|^o\d/i, levels: ["low", "medium", "high"] },
];

export const OPENAI_CONTEXT_LIMIT_PATTERNS: readonly string[] = [
  "context_length_exceeded",
  "exceeds the context window",
  "maximum context length",
];

export const manifest = defineAIProviderManifest({
  id: "openai",
  label: "OpenAI",
  description: "Connect directly to OpenAI's API.",
  defaultBaseUrl: "https://api.openai.com",
  connectorIdentifier: "openai",
  endpointFromConnector: true,
  defaultChatModel: "gpt-5",
  defaultFastModel: "gpt-5-mini",
  defaultChatEffort: "medium",
  modelEfforts: OPENAI_MODEL_EFFORTS,
  configurable: true,
  requiresChatModel: false,
  contextLimitPatterns: OPENAI_CONTEXT_LIMIT_PATTERNS,
  credentialFields: [
    {
      key: "apiKey",
      label: "API key",
      description: "Stored securely on the server.",
      placeholder: "sk-…",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: (v) => ({ baseUrl: "", apiKey: v.apiKey?.trim() ?? "" }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl, apiKey: "" }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    maxImageDimension: 2000,
  },
});
